import { SVGProps } from 'react';

export const IconSystemAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 48 48'
    {...props}
  >
    <rect width={48} height={48} fill='#228BE6' rx={24} />
    <path
      fill='#fff'
      d='m20.807 39-.01-3.998c.824 0 1.52-.581 2.582-1.523 1.231-1.082 2.76-2.435 5.024-2.505 1.112-.08 2.314-.18 3.515-.301 1.172-.12 2.324-1.273 2.403-2.425.268-3.838.268-5.732-.01-9.59-.09-1.172-1.3-2.354-2.492-2.434-5.183-.291-10.456-.291-15.659 0-1.181.07-2.393 1.262-2.482 2.445-.278 3.878-.278 5.821 0 9.72.09 1.172 1.3 2.354 2.492 2.424 1.54.09 3.058.15 4.627.18v4.009c-1.608-.04-3.267-.1-4.855-.19-3.188-.2-5.978-2.946-6.226-6.133-.288-4.098-.288-6.233 0-10.321.258-3.187 3.048-5.932 6.226-6.133 5.352-.3 10.773-.3 16.115 0 3.187.2 5.977 2.947 6.226 6.133.288 4.058.288 6.142.01 10.18-.239 3.127-2.86 5.812-5.988 6.123-1.24.12-2.472.22-3.693.31-.884.03-1.57.602-2.622 1.524C24.73 37.607 23.16 39 20.807 39Z'
    />
  </svg>
);
